import React from 'react';
import { Box } from '@mui/material';
import { LayoutItem } from 'react-grid-layout';
import { ReactComponent as LowTempIcon } from '../../../../../../../../assets/dashboard/LowTemp.svg';
import {
  ILabelValuePanel,
  ILowTempPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';

export interface LowTempPanelProps {
  panel: ILowTempPanel; // Replace with specific panel type if available
  layout?: LayoutItem | undefined;
}

function LowTempPanel(props: LowTempPanelProps) {
  const { panel, layout } = props;
  //   const { typeRequest } = panel;
  //   const { t } = useTranslation();
  const mockValue = 5; // Replace with actual data fetching logic

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `low_temp`, // Ensure this ID is unique across panels
    title: panel.title,
    icon: <LowTempIcon height={'100%'} />,
    content: (
      <Box
        width="100%"
        height={'100%'}
        minWidth={120}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        {mockValue}
      </Box>
    ),
    // loading: isFetching,
    // error: errorDevicesConnectionStatus
    //   ? t('dashboard.error.fetching')
    //   : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default LowTempPanel;
